import { FC } from 'react'
import { Empty } from 'antd'
import {
  LoadingOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import Button from '@UI/New/Button'
import Preloader from '@UI/Preloader'
import type { TaskTrackerAccessibleUser } from '../../../../../lib/taskTrackerBoardAccessibleUsers.utils'
import TaskHistoryItem from './TaskHistoryItem'
import { useTaskTrackerTaskHistory } from './useTaskTrackerTaskHistory'
import classes from './index.module.css'

const iconProps = {
  onPointerEnterCapture: undefined,
  onPointerLeaveCapture: undefined,
} as const

type TaskHistorySectionProps = {
  taskId: number | null
  boardId: number | null
  accessibleUsers: TaskTrackerAccessibleUser[]
  refreshToken?: string
}

const TaskHistorySection: FC<TaskHistorySectionProps> = ({
  taskId,
  boardId,
  accessibleUsers,
  refreshToken = '',
}) => {
  const { events, loading, error, lookups, reload } = useTaskTrackerTaskHistory({
    taskId,
    boardId,
    accessibleUsers,
    refreshToken,
  })

  return (
    <section className={classes.root}>
      <div className={classes.header}>
        <h3 className={classes.title}>История</h3>
        <Button
          variant="action"
          color="gray"
          className={classes.refreshBtn}
          disabled={loading || taskId == null}
          onClick={() => void reload()}
          leftContent={
            loading ? (
              <LoadingOutlined spin {...iconProps} />
            ) : (
              <ReloadOutlined {...iconProps} />
            )
          }
        >
          Обновить
        </Button>
      </div>

      {loading ? (
        <div className={classes.state} aria-busy="true">
          <Preloader />
        </div>
      ) : null}

      {!loading && error ? <p className={classes.error}>{error}</p> : null}

      {!loading && !error ? (
        <div className={cnScroll(classes.timelineScroll)}>
          {events.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="История пока пуста"
              className={classes.emptyState}
            />
          ) : (
            events.map((event) => (
              <TaskHistoryItem
                key={event.id}
                event={event}
                lookups={lookups}
              />
            ))
          )}
        </div>
      ) : null}
    </section>
  )
}

const cnScroll = (className: string) => `custom-scroll ${className}`

export default TaskHistorySection
